module.exports = __webpack_public_path__ + "assets/img/Coolabah-Turf-Service-Page-w540.a3a0f024.jpg";